import { useEffect, useState } from 'react';

/** Current time, re-rendering every `intervalMs` (default 60 s) so relative times stay fresh. */
export function useNow(intervalMs = 60_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);
  return now;
}
